class Footer {
	constructor(el) {
		this.el = el;
		this.giveLivelyRow = this.el.querySelector('.site-footer__give-lively-row');
		
		this.init();
	}
	
	init() {
		// Check if the give-lively row is enabled
		if (this.giveLivelyRow) {
			this.addPaddingToLastSection();
		}
	}
	
	addPaddingToLastSection() {
		// Find the main element that comes before the footer
		const footer = this.el;
		const main = document.querySelector('main');
		
		if (main) {
			// Find all section.block-container elements within main
			const sectionBlocks = main.querySelectorAll('section.block-container');
			
			if (sectionBlocks.length > 0) {
				// Get the last section.block-container
				const lastSection = sectionBlocks[sectionBlocks.length - 1];
				
				// Add 20rem padding-bottom
				lastSection.style.paddingBottom = '15rem';
			}
		}
	}
}

export default Footer;
